import { j as e } from "./atoms-v218.js";
import { forwardRef as ee, useState as H, useContext as te, useCallback as se } from "react";
import ne from "./atoms-v2122.js";
import { Icon as G } from "./atoms-v217.js";
import { InputContainer as ie } from "./atoms-v2114.js";
import { InputHelper as v } from "./atoms-v220.js";
import { InputInterior as re } from "./atoms-v2128.js";
import { InputLabel as le } from "./atoms-v2129.js";
import { InputOutline as oe } from "./atoms-v223.js";
import { TextInputSkeleton as ce } from "./atoms-v2746.js";
import { Tooltip as M } from "./atoms-v246.js";
import { useMergedRefs as ae } from "./atoms-v2712.js";
import { FormGroupContext as ue } from "./atoms-v2130.js";
import { Input as de, Icons as N } from "./atoms-v2747.js";
const fe = ee(
  ({
    className: z = "",
    colorTheme: o = "light",
    defaultValue: O = "",
    disabled: C = !1,
    error: p,
    helperText: S,
    icon: k,
    id: V,
    isSkeleton: P = !1,
    label: _,
    name: g,
    onBlur: b,
    onFocus: F,
    readOnly: R = !1,
    tooltip: y,
    type: f = "text",
    variant: x = "productive",
    ...q
  }, A) => {
    const [J, $] = H(O), [K, L] = H(!1), { isGroupedInput: E } = te(ue), Q = se((i) => {
      $(ne(i, "value", "0"));
    }, []), T = ae([A, Q]), U = (i) => {
      L(!1), b && typeof b == "function" && b(i);
    }, W = (i) => {
      L(!0), F && typeof F == "function" && F(i);
    }, X = (i) => {
      if (f !== "credit-card" && f !== "expiration-date")
        return;
      const s = i.currentTarget, c = s.value.slice(0, s.selectionStart ?? 0).replace(/\D/g, "").length, D = s.value.replace(/\D/g, "");
      let t = "";
      if (f === "credit-card")
        t = D.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
      else {
        const n = D.slice(0, 4), l = n.slice(0, 2), j = n.slice(2, 4);
        n.length <= 2 ? t = n.length === 2 ? `${l}/` : l : t = `${l}/${j}`;
      }
      s.value = t;
      let r = 0, a = 0;
      for (let n = 0; n < t.length && (/\d/.test(t[n]) && a++, r = n + 1, !(a >= c)); n++)
        ;
      f === "expiration-date" && c === 2 && t.length >= 3 && t[2] === "/" && r === 2 && (r = 3), s.setSelectionRange(r, r), $(t);
    }, Y = (i) => {
      if (f !== "expiration-date")
        return;
      const s = i.currentTarget, c = s.selectionStart ?? 0, D = s.selectionEnd ?? 0;
      if (c === D) {
        if (i.key === "Backspace" && c > 0 && s.value[c - 1] === "/") {
          i.preventDefault();
          let t = s.value.replace(/\D/g, "");
          const r = s.value.slice(0, c - 1).replace(/\D/g, "").length, a = r - 1;
          a >= 0 && (t = t.slice(0, a) + t.slice(a + 1));
          const n = t.slice(0, 4), l = n.slice(0, 2), j = n.slice(2, 4), u = n.length <= 2 ? `${n.length === 2 ? `${l}/` : l}` : `${l}/${j}`;
          s.value = u;
          const B = Math.max(0, r - 1);
          let m = 0, I = 0;
          for (let d = 0; d < u.length && (/\d/.test(u[d]) && I++, m = d + 1, !(I >= B)); d++)
            ;
          s.setSelectionRange(m, m), $(u);
          return;
        }
        if (i.key === "Delete" && c < s.value.length && s.value[c] === "/") {
          i.preventDefault();
          let t = s.value.replace(/\D/g, "");
          const r = s.value.slice(0, c).replace(/\D/g, "").length, a = r;
          a < t.length && (t = t.slice(0, a) + t.slice(a + 1));
          const n = t.slice(0, 4), l = n.slice(0, 2), j = n.slice(2, 4), u = n.length <= 2 ? `${n.length === 2 ? `${l}/` : l}` : `${l}/${j}`;
          s.value = u;
          const B = r;
          let m = 0, I = 0;
          for (let d = 0; d < u.length && (/\d/.test(u[d]) && I++, m = d + 1, !(I >= B)); d++)
            ;
          s.setSelectionRange(m, m), $(u);
          return;
        }
      }
    };
    if (P)
      return /* @__PURE__ */ e.jsx(ce, { className: z, helperText: S, variant: x });
    const h = !!p, w = `${g}_errormessage`, Z = J !== "";
    return /* @__PURE__ */ e.jsxs(ie, { className: z, variant: x, children: [
      /* @__PURE__ */ e.jsxs(
        oe,
        {
          colorTheme: o,
          isDisabled: C || R,
          isErrored: h,
          isFocused: K && !R,
          isGroupedInput: E,
          variant: x,
          children: [
            /* @__PURE__ */ e.jsx(
              le,
              {
                colorTheme: o,
                hasValue: Z,
                htmlFor: V || g,
                isDisabled: C,
                isFocused: K,
                variant: x,
                children: _
              }
            ),
            /* @__PURE__ */ e.jsxs(re, { children: [
              /* @__PURE__ */ e.jsx(
                de,
                {
                  $colorTheme: o,
                  $variant: x,
                  "aria-invalid": h,
                  autoComplete: g,
                  defaultValue: O,
                  disabled: C,
                  id: V || g,
                  inputMode: f === "credit-card" ? "numeric" : void 0,
                  name: g,
                  onBlur: U,
                  onFocus: W,
                  onInputCapture: X,
                  onKeyDown: Y,
                  readOnly: R,
                  ref: T,
                  type: f,
                  ...h && { "aria-describedby": w },
                  ...q
                }
              ),
              k || y ? /* @__PURE__ */ e.jsxs(N, { $colorTheme: o, children: [
                k && /* @__PURE__ */ e.jsx(G, { name: k, size: "medium" }),
                y && /* @__PURE__ */ e.jsxs(M, { colorTheme: o, children: [
                  /* @__PURE__ */ e.jsx(M.Trigger, { children: /* @__PURE__ */ e.jsx(G, { name: "information", size: "medium" }) }),
                  /* @__PURE__ */ e.jsx(M.Content, { children: y })
                ] })
              ] }) : null,
              h ? /* @__PURE__ */ e.jsx(N, { $isErrored: !0, $colorTheme: o, children: h && /* @__PURE__ */ e.jsx(G, { name: "warning-filled", size: "medium" }) }) : null
            ] }),
            E ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(v, { isGroupedInput: !0, colorTheme: o, children: !p && S }),
              /* @__PURE__ */ e.jsx(v, { isError: !0, isGroupedInput: !0, colorTheme: o, id: w, children: p })
            ] }) : null
          ]
        }
      ),
      E ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(v, { colorTheme: o, children: !p && S }),
        /* @__PURE__ */ e.jsx(v, { isError: !0, colorTheme: o, id: w, children: p })
      ] })
    ] });
  }
);
fe.displayName = "TextInput";
export {
  fe as TextInput
};
